(function () {
  const btn = document.getElementById('coming-soon-btn');
  if (!btn) return;

  const release = new Date(btn.dataset.release);

  function ordinal(n) {
    const s = ['th', 'st', 'nd', 'rd'];
    const v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  }

  function update() {
    const now = new Date();
    if (release - now <= 0) { btn.textContent = 'AVAILABLE NOW'; return; }

    const timeJST = release.toLocaleString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
      timeZone: 'Asia/Tokyo'
    }).toLowerCase().replace(' ', '');

    const nowJST = new Date(now.toLocaleString('en-US', { timeZone: 'Asia/Tokyo' }));
    const releaseJST = new Date(release.toLocaleString('en-US', { timeZone: 'Asia/Tokyo' }));
    nowJST.setHours(0, 0, 0, 0);
    releaseJST.setHours(0, 0, 0, 0);
    const days = Math.round((releaseJST - nowJST) / 86400000);

    if (days === 0) {
  btn.textContent = `RELEASE TODAY — ${timeJST} JST`;
} else if (days === 1) {
  btn.textContent = `RELEASE TOMORROW — ${timeJST} JST`;
} else {
      const month = release.toLocaleString('en-US', { month: 'long', timeZone: 'Asia/Tokyo' }).toUpperCase();
      const day = parseInt(release.toLocaleString('en-US', { day: 'numeric', timeZone: 'Asia/Tokyo' }));
      btn.textContent = `RELEASE ON ${month} ${ordinal(day)} — ${timeJST} JST`;
    }

    setTimeout(update, 60000);
  }

  update();
})();